import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {DEFAULT_INPUT_DEBOUNCE_MS} from '@shared/constants/debounce.constants';
import {LeftPanelHelper} from '@shared/helpers/left-panel.helper';
import {LeftPanelActions} from '@store/left-panel/actions';
import {of} from 'rxjs';
import {debounceTime, switchMap} from 'rxjs/operators';

/**
 * This class is an injectable Angular service that provides a way to fetch data for Left Panel Page.
 */
@Injectable()
export class LeftPanelEffects {
	/**
	 * This function creates an Angular effect that load pages.
	 * @returns an Observable that emits data when the effect completes
	 */
	loadPages$ = createEffect(() =>
		this.actions$.pipe(
			ofType(LeftPanelActions.load.requested),
			debounceTime(DEFAULT_INPUT_DEBOUNCE_MS),
			switchMap(() =>
				of(
					LeftPanelActions.load.succeeded({
						pages: LeftPanelHelper.getPages(),
					})
				)
			)
		)
	);

	/**
	 * Constructor
	 * @param actions$ actions$
	 */
	constructor(private actions$: Actions) {}
}
